export default __webpack_public_path__ + "static/media/default-avatar.e4bd5b07.jpg";